var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84661 1.36205C9.84661 1.04011 9.58536 0.778858 9.26342 0.778858C9.20008 0.778858 9.13675 0.789414 9.08133 0.807886L9.04439 0.82108C9.04439 0.82108 9.03911 0.82108 9.03647 0.823719L6.59288 1.74205L2.90374 0.171918C2.87735 0.156085 2.84832 0.142891 2.81666 0.134974C2.78235 0.124419 2.74541 0.119141 2.70846 0.119141C2.49208 0.119141 2.31527 0.295945 2.31527 0.512333C2.31527 0.63636 2.37333 0.747192 2.46041 0.818442C2.47888 0.831636 2.49735 0.84483 2.51846 0.858024L4.75622 2.36218L2.62666 3.21717C2.44985 3.28842 2.2493 3.28578 2.07513 3.20926L1.32042 2.88204C1.27292 2.86357 1.22278 2.85037 1.16736 2.85037C0.950974 2.85037 0.77417 3.02717 0.77417 3.24356C0.77417 3.36759 0.832224 3.47842 0.921946 3.54967C0.950974 3.57342 0.98528 3.59453 1.02222 3.60773L2.36277 4.38356C2.44194 4.42842 2.5343 4.43633 2.62138 4.40467L9.40064 1.92413C9.4455 1.91357 9.48772 1.89774 9.5273 1.87927C9.7173 1.78163 9.84661 1.58635 9.84661 1.35941V1.36205Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAirport);
export default __webpack_public_path__ + "static/media/Ic_Airport.a06b96814106c030fe839fbe2d2ed6bb.svg";
export { ForwardRef as ReactComponent };